<template>
  <b-card>
    <table-hot-alert-condition />
  </b-card>
</template>

<script>
import TableHotAlertCondition from '@/layouts/components/TableHotAlertCondition.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TableHotAlertCondition,
    BCard,
  },
}
</script>
